<script>

let props = $props();

function triggerSelect(e)
{
    e.preventDefault();
    e.target.closest('.edit-avatar').querySelector('input[type=file]').click();
}

function triggerPreview(e)
{
    e.target.closest('.edit-avatar').querySelector('img').src = URL.createObjectURL(e.target.files[0]);
}

</script>

<div class="edit-avatar">
    <button onclick="{ triggerSelect }">
        <img src="{ props.img_url }" class="rounded-circle" alt="User Avatar">
    </button>

    <input type="file" accept="image/*" name="avatar" hidden onchange="{ triggerPreview }">
</div>
